module.exports = __webpack_public_path__ + "static/media/megaphone.09e197bd.png";